(function () {
  angular
    .module("akitabox.desktop.media-viewer")
    .controller(
      "MediaViewerContainerController",
      MediaViewerContainerController
    );

  /* @ngInject */
  function MediaViewerContainerController(
    // Angular
    $rootScope,
    // Constants
    EVENT_MEDIA_ROTATE,
    // Services
    FeatureFlagService,
    ToastService,
    UserService,
    // Dialogs
    DownloadDocumentDialog,
    // Resolves
    building,
    document
  ) {
    var self = this;

    var permissions = UserService.getPermissions();

    // Attributes
    self.building = building;
    self.document = document;
    self.canRotate = permissions.document.rotate;

    // Functions
    self.onRotate = onRotate;
    self.onDownload = onDownload;

    // =================
    // Public Functions
    // =================
    function onRotate() {
      $rootScope.$broadcast(EVENT_MEDIA_ROTATE);
    }

    function onDownload() {
      var locals = {
        docs: [self.document],
      };
      DownloadDocumentDialog.show({ locals: locals }).catch(
        ToastService.showError
      );
    }
  }
})();
